export default __webpack_public_path__ + "static/media/shared-leadership.4d325408.svg";